import * as Sentry from '@sentry/react';

export const ErrorBoundary = Sentry.ErrorBoundary;
